/**
 * Set a cookie.
 * @param {String} name = name of cookie to set
 * @param {String} value = value of the cookie
 * @param {Date} maxAge = expire in specific number of seconds
 * @param {Number} days = if expireOn is undefined then days from now will be used
 */
export function setCookie (name, value, maxAge, days = 1) {
  var expires = ''
  if (maxAge) {
    expires = '; max-age=' + maxAge
  } else if (days) {
    var date = new Date()
    date.setHours(23, 59, 59, 0)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/'
}

export function getCookie (name) {
  var nameEQ = name + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return undefined
}

export function eraseCookie (name) {
  document.cookie = name + '=; Max-Age=-99999999;'
}
